export default __webpack_public_path__ + "static/media/download.a823ee63.svg";